import apiClient from './client'

export const messageService = {
  getMessages:    (conversationId) => apiClient.get('/messages', { params: { id_conversa: conversationId } }),
  sendMessage:    (data)           => apiClient.post('/messages', data),
  updateMessage:  (id, message)    => apiClient.put(`/messages/${id}`, { message }),
  toggleLike:     (id)             => apiClient.post(`/messages/${id}/like`),
  deleteMessage:  (id)             => apiClient.delete(`/messages/${id}`),
  getUnreadCount: ()               => apiClient.get('/messages/unread'),
  markRead:       (conversationId) => apiClient.post('/messages/mark-read', { id_conversa: conversationId }),
  sendTyping:     (conversationId) => apiClient.post('/messages/typing', { id_conversa: conversationId }),
}

export const conversationService = {
  getConversations:   ()          => apiClient.get('/conversations'),
  getConversationById:(id)        => apiClient.get(`/conversations/${id}`),
  createConversation: (contactId) => apiClient.post('/conversations', { client_id: contactId }),
}

export default messageService
